import { FunctionComponent } from 'react'
import cx from 'classnames'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import GroupContainer from 'redux/containers/components/accordion/GroupContainer'
import ContentComponentContainer from 'redux/containers/components/accordion/ContentComponentContainer'
import { AccordionGroup } from 'interfaces/accordion'

const AccordionContainer: FunctionComponent<AccordionContainerProps> = ({ group, depth = 1, ...props }) => {
  const isRootNode = depth === 1

  return (
    <ResponseConsumer
      response={group}
      pendingComponent={undefined}
      offlineProps={{ title: 'Content not available offline' }}
      content={() => <GroupNodes {...{ group, depth, isRootNode, ...props }} />}
    />
  )
}

export default AccordionContainer

const GroupNodes: FunctionComponent<GroupNodesProps> = ({ group, isRootNode, ...props }) => (
  <ul className={cx({ group: true, 'cd-accordion-menu': isRootNode })}>
    {Array.isArray(group) && group.map((node) =>
      <NodeComponent key={node.id} {...{ node }} {...props} />
    )}
  </ul>
)

const NodeComponent: FunctionComponent<NodeComponentProps> = ({ node, ...props }) => {
  const { nodeType, id } = node
  switch (nodeType) {
    case 'group':
      return (<GroupContainer key={id} {...props} {...node} />)
    case 'content':
      return (<ContentComponentContainer key={id} {...props} {...node} />)
    default:
      return null
  }
}

interface NodeComponentProps {
  aol: string | string[]
  node: AccordionGroup
  depth: number
}

interface GroupNodesProps {
  group: number | AccordionGroup[]
  isRootNode: boolean
  depth: number
  aol: string | string[]
}

interface AccordionContainerProps {
  group: number | AccordionGroup[]
  depth?: number
  aol: string | string[]
}
